<div class="flex justify-between items-start max-md:justify-center max-md:items-center">
  <div class="mb-[50px] max-md:my-[30px]">
    <h1 class="booking-header-title">{{ (routeData$ | async)?.['title'] | translate }}</h1>
  </div>
</div>
